import { getMarketplaceItemInventory, generateInventoryFile } from './asyncThunks';

export const getMarketplaceItemInventoryBuilder = builder => {
  builder.addCase(getMarketplaceItemInventory.pending, state => {
    state.getMarketplaceItemInventoryPending = true;
  });
  builder.addCase(getMarketplaceItemInventory.fulfilled, (state, { payload }) => {
    state.getMarketplaceItemInventoryPending = false;
    const { data } = payload;
    state.marketplaceItemInventory = data;
  });
  builder.addCase(getMarketplaceItemInventory.rejected, state => {
    state.getMarketplaceItemInventoryPending = false;
  });
};

export const generateInventoryFileBuilder = builder => {
  builder.addCase(generateInventoryFile.pending, state => {
    state.generateInventoryFilePending = false;
  });
  builder.addCase(generateInventoryFile.fulfilled, (state, action) => {
    state.generateInventoryFilePending = false;
  });
  builder.addCase(generateInventoryFile.rejected, state => {
    state.generateInventoryFilePending = false;
  });
};
